import axios from 'axios';
import constants from '../constant';
import { withAuthRetry } from './http/refresh';

const baseURL = constants.apiUrl;

/**
 * The app's general-purpose client. It carries the session token on every request and, on a
 * single 401, refreshes once and tries again, sharing that refresh with every other client
 * so two of them cannot rotate the refresh token underneath each other.
 */
export default withAuthRetry(
  axios.create({
    baseURL: baseURL,
  })
);
